import LivingMap from '../map/livingmap';
import MapControl from './map-control';

/**
 * The aim of this class is to provide a React.Component esque wrapper around plugins.
 * We should aim to provide a list of lifecyle based events that many plugins might want to use.
 * @class LivingMapPlugin
 */
class LivingMapPlugin implements MapControl {
  public activated = false;
  protected LMMap: LivingMap;
  private id: string;

  /**
   * use the constructor to initialze any additional classes + set up any other relevant building blocks.
   * @constructor
   * @param  {LivingMap} LMMap
   */
  public constructor(id: string, LMMap: LivingMap) {
    this.LMMap = LMMap;
    this.id = id;
  }

  /**
   * returns the unique identiefer of this map plugin.
   */
  public getId(): string {
    return this.id;
  }

  /**
   * use the activate() function to act, and make use of the map. in the construct, NO guarentee is made the map will be active
   * and neither will the stylesheet be.
   * This is also the best place to activate listeners and other such timeouts.
   * @returns {void}
   */
  public activate(): void {
    return;
  }

  /**
   * use the deactivate() function to clean up anything like listeners and timeouts to avoid any memory leaks.
   * @returns {void}
   */
  public deactivate(): void {
    return;
  }

  /**
   * use the refresh() lifecycle to deal with any stylesheet refreshes.
   * @returns {void}
   */
  public refresh(): void {
    return;
  }
}

export default LivingMapPlugin;
